import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
import { useGSAP } from "@gsap/react";

gsap.registerPlugin(ScrollTrigger, SplitText, useGSAP);

/** Media query every animation is gated behind. */
export const MOTION_OK = "(prefers-reduced-motion: no-preference)";

export const EASE_OUT = "expo.out";

export { gsap, ScrollTrigger, SplitText, useGSAP };

/** Builds a selector from a CSS Modules class name (hashes can contain characters like "+"). */
export const sel = (className: string) => `.${CSS.escape(className)}`;
